import { render, staticRenderFns } from "./FirstSettingsComp.vue?vue&type=template&id=5effa20f&scoped=true&"
import script from "./FirstSettingsComp.vue?vue&type=script&lang=js&"
export * from "./FirstSettingsComp.vue?vue&type=script&lang=js&"
import style0 from "./FirstSettingsComp.vue?vue&type=style&index=0&id=5effa20f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5effa20f",
  null
  
)

export default component.exports